import { render, staticRenderFns } from "./BloodTransfusionIncidents.vue?vue&type=template&id=6d20c000&"
import script from "./BloodTransfusionIncidents.vue?vue&type=script&lang=js&"
export * from "./BloodTransfusionIncidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports